import {
  GET_DAILY_RATES_REQUEST,
  GET_DAILY_RATES_SUCCESS,
  GET_DAILY_RATES_FAILURE,
  CREATE_DAILY_RATE_REQUEST,
  CREATE_DAILY_RATE_SUCCESS,
  CREATE_DAILY_RATE_FAILURE,
  UPDATE_DAILY_RATE_REQUEST,
  UPDATE_DAILY_RATE_SUCCESS,
  UPDATE_DAILY_RATE_FAILURE,
  DELETE_DAILY_RATE_REQUEST,
  DELETE_DAILY_RATE_SUCCESS,
  DELETE_DAILY_RATE_FAILURE,
} from '../types';
import api from '../../services/api';

// Get all daily rates
export const getDailyRates = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_DAILY_RATES_REQUEST });

    const response = await api.get('/daily-rates', { params });
    const data = response.data.data;
    const pagination = response.data.pagination;

    dispatch({
      type: GET_DAILY_RATES_SUCCESS,
      payload: { data, pagination },
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get daily rates';
    dispatch({
      type: GET_DAILY_RATES_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Create daily rate
export const createDailyRate = (rateData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_DAILY_RATE_REQUEST });

    const response = await api.post('/daily-rates', rateData);
    const data = response.data.data;

    dispatch({
      type: CREATE_DAILY_RATE_SUCCESS,
      payload: data,
    });

    return { success: true, data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create daily rate';
    dispatch({
      type: CREATE_DAILY_RATE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Update daily rate
export const updateDailyRate = (id, rateData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_DAILY_RATE_REQUEST });

    const response = await api.put(`/daily-rates/${id}`, rateData);
    const data = response.data.data;

    dispatch({
      type: UPDATE_DAILY_RATE_SUCCESS,
      payload: data,
    });

    return { success: true, data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update daily rate';
    dispatch({
      type: UPDATE_DAILY_RATE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Delete daily rate
export const deleteDailyRate = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_DAILY_RATE_REQUEST });

    await api.delete(`/daily-rates/${id}`);

    dispatch({
      type: DELETE_DAILY_RATE_SUCCESS,
      payload: id,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to delete daily rate';
    dispatch({
      type: DELETE_DAILY_RATE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

